"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _reactKonva = require("react-konva");

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

var LeftLine = function LeftLine(_ref) {
  var rectHeight = _ref.rectHeight,
      rectLocationX = _ref.rectLocationX,
      rectLocationY = _ref.rectLocationY,
      warningInfo = _ref.warningInfo,
      initWarning = _ref.initWarning,
      addHorizontalLine = _ref.addHorizontalLine;

  var _useState = (0, _react.useState)(false),
      _useState2 = _slicedToArray(_useState, 2),
      showDot = _useState2[0],
      setShowDot = _useState2[1];

  var _useState3 = (0, _react.useState)(),
      _useState4 = _slicedToArray(_useState3, 2),
      dotLocationY = _useState4[0],
      setDotLocationY = _useState4[1];

  var _useState5 = (0, _react.useState)(false),
      _useState6 = _slicedToArray(_useState5, 2),
      showWarning = _useState6[0],
      setShowWarning = _useState6[1];

  var mouseEntre = function mouseEntre(e) {
    setDotLocationY(e.evt.offsetY);
    setShowDot(true);
  };

  var mouseLeave = function mouseLeave(e) {
    setDotLocationY();
    setShowDot(false);
  };

  var mouseMove = function mouseMove(e) {
    setDotLocationY(e.evt.offsetY);
  };

  (0, _react.useEffect)(function () {
    if (typeof warningInfo !== "undefined" && initWarning !== null) {
      setShowWarning(warningInfo["colourWarning"] || initWarning["colourWarning"]);
    } else if (typeof warningInfo === "undefined" && initWarning !== null) {
      setShowWarning(initWarning["colourWarning"]);
    } else if (typeof warningInfo !== "undefined" && initWarning === null) {
      setShowWarning(warningInfo["colourWarning"]);
    } else {
      setShowWarning(false);
    }
  }, [warningInfo, initWarning]);
  return /*#__PURE__*/_react.default.createElement(_react.Fragment, null, showDot && /*#__PURE__*/_react.default.createElement(_reactKonva.Line, {
    listening: true,
    lineCap: "round",
    x: rectLocationX,
    y: dotLocationY,
    points: [0, 0, 0, 0, 0, 0],
    stroke: showWarning ? "#ffc107" : "#198038",
    strokeWidth: 10,
    opacity: 1,
    id: "leftDot"
  }), /*#__PURE__*/_react.default.createElement(_reactKonva.Line, {
    listening: true,
    lineCap: "butt",
    x: rectLocationX,
    y: rectLocationY,
    points: [0, 0, 0, 0, 0, rectHeight],
    stroke: showWarning ? "#ffc107" : "#198038",
    strokeWidth: 14,
    opacity: 0,
    id: "leftLine",
    onMouseover: mouseEntre,
    onMouseOut: mouseLeave,
    onMouseMove: mouseMove,
    onClick: addHorizontalLine
  }));
};

var _default = LeftLine;
exports.default = _default;